import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { API } from "../lib/api";
import { PROJECT_CATEGORIES } from "../constants/content";

export const categoryLabel = (slug) => PROJECT_CATEGORIES.find((c) => c.slug === slug)?.label || slug;

export default function ProjectCard({ project, index = 0 }) {
  const cover = project.photos?.find((p) => p.id === project.cover) || project.photos?.[0];
  const imgSrc = cover ? `${API}/media/${project.id}/${cover.id}` : null;
  return (
    <Link
      to={`/projects/${project.id}`}
      data-testid={`project-card-${project.id}`}
      className="group block bg-white border border-line hover:border-ink/30 transition-colors"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-charcoal">
        {imgSrc ? (
          <img src={imgSrc} alt={`${project.name} — ${categoryLabel(project.category)} project in ${project.location || "Wellington"}`} className="w-full h-full object-cover img-duotone transition-transform duration-700 group-hover:scale-105" loading={index > 2 ? "lazy" : "eager"} />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <img src="/logo-mark-white.png" alt="" className="w-14 opacity-30" />
          </div>
        )}
        <span className="absolute top-3 left-3 bg-ink/85 text-white font-mono text-[10px] tracking-[0.18em] uppercase px-2.5 py-1.5">{categoryLabel(project.category)}</span>
      </div>
      <div className="p-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-display font-semibold text-lg text-ink leading-snug">{project.name}</h3>
          {project.location && (
            <p className="mt-1.5 inline-flex items-center gap-1.5 text-xs text-slate2 font-mono tracking-wider uppercase">
              <MapPin className="w-3 h-3 text-gold" /> {project.location}
            </p>
          )}
        </div>
        <ArrowUpRight className="w-5 h-5 text-slate2 group-hover:text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0 mt-1" />
      </div>
    </Link>
  );
}
